import httpAdapter from '@libs/http';

import {
  install as installFeatureFlag,
  type FlagSource,
} from '@libs/feature-flag';

const TSE_API = `${import.meta.env.VITE_APP_TSE_API}api/v2`;

const source: FlagSource = {
  option: {
    enabled: false,
    sourceURL: TSE_API + '/useriswhiteinoption',
  },
  strategies: {
    enabled: false,
  },
  sltp: {
    enabled: true,
  },
};

const install = installFeatureFlag({ source, httpAdapter });

export { install };
